enum ProntoInvoiceStatus {
  Saved = 0,
  Submitted = 1,
  Accepted = 2,
  Rejected = 3,
  Acknowleged = 4,
  Queried = 5,
  Resubmitted = 6
}

export default ProntoInvoiceStatus;
